import React from 'react';

import DocumentItem from './DocumentItem';
import s from './index.module.css';
import { ISheetsBlockProps } from './types';

function SheetsBlock({ data: blockData }: ISheetsBlockProps) {
  return (
    <div className={s.sheetsBlock}>
      {blockData.data.documents.map((doc) => (
        <DocumentItem key={doc.id} doc={doc} />
      ))}
    </div>
  );
}

export default SheetsBlock;
